var _path, _circle, _circle2, _circle3, _circle4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategorySelection(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    width: 127,
    height: 128,
    viewBox: "0 0 127 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0651 125.845C97.895 125.845 126.13 97.6737 126.13 62.9225C126.13 28.1714 97.895 0 63.0651 0C28.2352 0 0 28.1714 0 62.9225C0 97.6737 28.2352 125.845 63.0651 125.845Z",
    fill: "#242D33",
    stroke: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.0227,
    cy: 34.0227,
    r: 8.59091,
    stroke: "#415360",
    strokeWidth: 2.86364
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.0227,
    cy: 61.7046,
    r: 8.59091,
    stroke: "current",
    strokeWidth: 2.86364
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.0227,
    cy: 89.3864,
    r: 8.59091,
    stroke: "#415360",
    strokeWidth: 2.86364
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.0227,
    cy: 117.068,
    r: 8.59091,
    stroke: "#415360",
    strokeWidth: 2.86364
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6362 29.7273H122",
    stroke: "#E6E8EC",
    strokeWidth: 2.86364,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M66.6362 38.3182H101.954",
    stroke: "current",
    strokeWidth: 2.86364,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6362 57.4091H88.5908",
    stroke: "#E6E8EC",
    strokeWidth: 2.86364,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M66.6362 66H110.545",
    stroke: "current",
    strokeWidth: 2.86364,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6362 85.0909H99.0908",
    stroke: "#E6E8EC",
    strokeWidth: 2.86364,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M66.6362 93.6818H105.773",
    stroke: "current",
    strokeWidth: 2.86364,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6362 112.773H111.5",
    stroke: "#E6E8EC",
    strokeWidth: 2.86364,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M66.6362 121.364H80.9544",
    stroke: "current",
    strokeWidth: 2.86364,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorySelection);
export default __webpack_public_path__ + "static/media/CategorySelection.8d11b02f70023f3f39a432149a7ab6ce.svg";
export { ForwardRef as ReactComponent };